import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';
import { truncateSplitCharacters } from '@Utils/String';

import './BuildQuerySubHeading.scss';

function BuildQuerySubHeading(props) {
  const MAX_QUERY_LENGTH = 70;

  const { query, structurePreview, showStructurePopup } = props;

  const renderHeading = () => {
    if (!query.text?.length && !structurePreview) {
      return (
        <div className="build-query-sub-heading">
          <h2 className="u-els-font-family-serif">
            Discover the <span className="u-els-font-family-serif-italic">most relevant insights</span>
          </h2>
          <h3 className="u-els-margin-top-1o2">with keywords, everyday language and AI summaries.</h3>
        </div>
      );
    }
    return (
      <div className="build-query-sub-heading__title">
        <h3 className="u-els-font-family-bold u-els-margin-right-1o2">Search for</h3>
        {query.text && <h3>&quot;{truncateSplitCharacters(query.text, MAX_QUERY_LENGTH)}&quot;</h3>}
        {query.text && structurePreview ? (
          <h3 className="title__separator title__separator-full u-els-padding-right-1o2 u-els-padding-left-1o2">AND</h3>
        ) : null}

        {structurePreview && (
          <ButtonWithIcon
            type="secondary"
            size="small"
            sprite="Structure"
            iconOnly
            tabIndex="0"
            data-e2e="e2e-build-query-heading-showStructure"
            onClick={() => showStructurePopup(structurePreview)}
            className="u-els-margin-right-1o2 title__icon"
            aria-label="Show quick search structure">
            Show quick search structure
          </ButtonWithIcon>
        )}
      </div>
    );
  };

  return (
    <div className={`${structurePreview ? 'build-query-sub-heading__container-structure' : 'build-query-sub-heading__container'}`}>
      {renderHeading()}
    </div>
  );
}

BuildQuerySubHeading.propTypes = {
  query: PropTypes.object,
  structurePreview: PropTypes.string,
  showStructurePopup: PropTypes.func.isRequired,
};

export default BuildQuerySubHeading;
